'use client';
import { Collapsible } from 'components/UI/Collapsible';
import FoundationPlayer from 'components/UI/FoundationPlayer/FoundationPlayer';
import type { VideoEncoding, WidgetVideoDetailProps } from 'types/videoTypes';
import styles from './detail.module.scss';

export const WidgetVideoDetail = ({ context }: { context: WidgetVideoDetailProps }) => {
  const video = context.items[0].model;
  const {
    lastmodifiedAt,
    fields: { title, subtitle, text, description },
  } = video;

  const publishDate = new Date(lastmodifiedAt);
  const isFast =
    video?.fields?.encoding?.length > 0 && !video?.fields?.encoding.find((enc: VideoEncoding) => enc.value.duration);

  return (
    <div>
      <h2 className={styles.headline}>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        {subtitle && title && <span className={styles.separator}>: </span>}
        {title && <span className={styles.title}>{title}</span>}
      </h2>
      {context.items[0] && <FoundationPlayer video={video} contentType={isFast ? 'fast' : 'vod'} embedType="intro" />}
      <div className={styles.date}>
        <time dateTime={lastmodifiedAt}>
          {publishDate.toLocaleDateString('de-DE', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}{' '}
          um{' '}
          {publishDate.toLocaleTimeString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          })}{' '}
          Uhr
        </time>
      </div>

      {description && (
        <div className={styles.content}>
          <p>{description}</p>
        </div>
      )}
      {text && (
        <Collapsible
          showMoreText="Videotranskript ausklappen"
          showLessText="Videotranskript einklappen"
          className={styles.text}
        >
          {text}
        </Collapsible>
      )}
    </div>
  );
};
